export enum EOnboardingStep {
  SETUP_BUILDING = 'setup-building',
  SETUP_ZONE = 'setup-zone',
  COMPANY_BRAND_SETTING = 'company-brand-setting',
  APPROVE_DECAL = 'approve-decal',
  ASSIGN_EMPLOYEE = 'assign-employee',
  ONBOARDING_REVIEW = 'onboarding-review',
  COMPLETED = 'completed',
  PAUSED = 'paused',
}

export enum EUserRole {
  BASIC = 'basic',
  ADMIN = 'admin',
  NO_ACCESS = 'no_access',
}

export enum EUserVerificationFlag {
  VERIFICATION_SUCCESS = 1,
  VERIFICATION_FAILED = 2,
}
